export class SearchFilter<T> {
  private getSearchField: (item: T) => string;

  constructor(getSearchField: (item: T) => string) {
    this.getSearchField = getSearchField
  }

  filter(list: T[], search: string): T[] {
    const normalizedSearch = search.trim().toLowerCase()
    if (!normalizedSearch) return list

    return list.filter(item => this.getSearchField(item).toLowerCase().includes(normalizedSearch))
  }
}

export default SearchFilter
